async.push(["ready", function() {
    initPhoneInputs();
}]);

window.initPhoneInputs = function initPhoneInputs() {
    let hasForm = false;
    $('form').each(function(f, form) {
        if ($(form).data('validate-phone')) {
            hasForm = form;
        }
    });

    if (hasForm) {
        let inputs = $(hasForm).data('validate-phone').split(',');
        let phoneInputs = [];

        inputs.forEach(function(sel) {
            // Initialize the phone drop down
            const phoneInput = document.querySelector(sel);
            let errorMsg = $(phoneInput).next('.error-message');
            const iti = window.intlTelInput(phoneInput, {
                autoPlaceholder: 'aggressive',
                initialCountry: 'nz',
                onlyCountries: ['nz','au'],
                separateDialCode: true,
                utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js',
            });
            phoneInputs.push({
                form: $(hasForm).attr('id'),
                sel: sel,
                object: iti
            });
        });
        if (window.phoneInput) {
            window.phoneInput = window.phoneInput.concat(phoneInputs);
        } else {
            window.phoneInput = phoneInputs;
        }
    }
}

window.setPhoneNumberGhosts = function setPhoneNumberGhosts(form) {
    if ($(form).data('validate-phone')) {
		let inputs = $(form).data('validate-phone').split(',');
		inputs.forEach(function(sel) {
			let fullName = sel.split('#')[1];
			let origName = $(form).find('#' + fullName).attr('name');

			let newName;
			let newMatch = origName.match(/(?![^\[]*\[)[^\]]+(?=\])/);
			if (newMatch) {
				newName = origName.replace(/(?![^\[]*\[)[^\]]+(?=\])/, newMatch[0] + '_full');
			} else {
				newName = origName + '_full';
			}
			setValidPhoneNumber(newName, sel);
		});
	}
}

window.setValidPhoneNumber = function setValidPhoneNumber(fieldName, fieldSel) {
    let currentInput = window.phoneInput.find(input => input.sel == fieldSel);
    let field = $('input[name="' + fieldName + '"]');
    field.val(currentInput.object.getNumber());
    return true;
}

window.validateAjaxPhoneNumber = function validateAjaxPhoneNumber(form) {
    let rules = {};
    if ($(form).data('validate-phone')) {
        // parse phone number
        $.validator.addMethod('parsePhone', function(value, element) {
            let currentInput = window.phoneInput.find((input) => {
                return input.sel == '#' + $(element)[0].id && input.form == $(form).attr('id');
            });
            let field = $(form).find('input[name=' + $(element)[0].name + '_full]');
            field.val(currentInput.object.getNumber());
            if (currentInput.object.isValidNumber()) {
                return true;
            }
            return false;
        }, "Phone number is invalid");

        let inputs = $(form).data('validate-phone').split(',');
        inputs.forEach(function(sel) {
            rules['' + $(sel).attr('name') + ''] = {
                parsePhone: true
            }
        });
    }
    return rules;
}

// AJAX submit function for modal suggest forms
// ---------------------------------------------------
window.submitAjaxForm = function submitAjaxForm(form) {
    // console.log('submit ajax');

    // get some values from our form
    var $form = $(form),
        // formData      = new FormData(form),
        formData = $form.serialize(),
        action = $form.attr('action'),
        submitBtn = $form.find('button[type=submit]'),
        submitBtnText = submitBtn.html();

    var formname = $(form).attr("name"); // form name
    var fsuccess = "#resp-success-" + formname; // form success response element
    var ferror = "#resp-error-" + formname; // form error response element
    var fname = $(form).attr('data-fname') ?? 'enquiry';

    // Send the data using post
    var posting = $.ajax({
        url: action,
        method: 'post',
        data: formData,
        dataType: 'json',
        beforeSend: function() {
            // do submit button loading state
            processFormSubmitBtn($form);
        },
        complete: function() {
            // remove loading animation
            resetSubmitBtn($(submitBtn), submitBtnText);
        }
    });

    // parse JSON data and do stuff - Put the results in a div
    posting.fail(function(xhr, status, error) {

        let json = xhr.responseJSON;

        // error handling
        // $(ferror).html('<div class="alert alert-danger"><h4><i class="fa fa-exclamation-triangle"></i> Error:</h4><ul>' + error + '</ul></div>');

        let errorMsg = json.message;
        let errorList = '';
        // loop through errors and show error message
        $.each(json.errors, function(i, error) {
            $.each(error, function(j, err) {
                errorList += '<li>' + err + '</li>';
            });
        });

        $(ferror).html('<div class="alert alert-danger"><h4><i class="fa fa-exclamation-triangle"></i>' + errorMsg + '</h4><ul>' + errorList + '</ul></div>');

        // track error event
        if (typeof ga !== 'undefined') {
            ga('send', 'event', 'form', 'error', $form.data('name'), 1);
        }
    });

    posting.done(function(json) {
        // enhanced tracking
        if (typeof window.gUserData === 'function') {
            gUserData(
                json.attributes.sha.sha256_email_address,
                json.attributes.sha.sha256_phone_number,
                json.attributes.sha.sha256_first_name,
                json.attributes.sha.sha256_last_name,
            );
        }

        let msg = '';
        switch (fname) {
            case 'enquiry':
            default:
                msg = '<strong>Enquiry sent successfully.</strong><br>Your enquiry has been received and we will be in contact shortly.';
                break;
            case 'testdrive':
                msg = '<strong>Thank you!</strong><br>Your test drive request has been submitted successfully. We will be in contact with you shortly.';
                break;
        }

        $(ferror).html('');
        $(fsuccess).html('<p class="alert alert-success" id="form-success-' + fname + '">' + msg +'</p>');

        // fade out alert after 5 secs
        $(".alert.fade").delay(5000).addClass("in").fadeOut('slow');

        // track success event
        if (typeof ga !== 'undefined') {
            ga('send', 'event', 'form', 'success', $form.data('name'), 1);
        }
    });
}

window.resetSubmitBtn = function resetSubmitBtn(btn, html) {
    btn.html(html).removeClass('disabled').prop('disabled', false);
}